import * as React from 'react';

// API
import apibridge from '../../../apibridge';

// UTILS
import { validationErrorsToString } from '../../../utils';

// PACKAGES
import { SwitchTransition, CSSTransition } from 'react-transition-group';

// COMPONENTS
import Button from '../../../components/Button';
import LoadingSpinner from '../../../components/LoadingSpinner';

// ICONS
import { ReactComponent as AlertIcon } from '../../../assets/svg/alert.svg';

// TYPES
import { ComplaintFetchUserProfile, ComplaintRemoveFamilyMemberCommand } from '../../../api/models';
import { closeModalType } from '../../../components/GlobalModal';

interface RemoveModalTypes {
	closeModal?: closeModalType;
	complaintId: string;
	familyMemberDetail: ComplaintFetchUserProfile;
	getComplaintsDetailsData: () => Promise<void>;
}

const RemoveModal: React.FC<RemoveModalTypes> = ({
	closeModal,
	complaintId,
	getComplaintsDetailsData,
	familyMemberDetail
}) => {
	// Error and Loading state
	const [formErrorMessage, setFormErrorMessage] = React.useState<string>('');

	const [isLoading, setIsLoading] = React.useState<boolean>(false);

	const confirmRemove = async () => {
		setIsLoading(true);

		const data: ComplaintRemoveFamilyMemberCommand = {
			id: familyMemberDetail.id,
			complaintId: complaintId
		};

		const response = await apibridge.removeFamilyMember(data);

		if (response.isError) {
			setIsLoading(false);

			setFormErrorMessage(
				response.validationErrors.length
					? validationErrorsToString(response.validationErrors)
					: response.message || 'An error has occurred'
			);
		} else {
			setIsLoading(false);

			if (closeModal) {
				closeModal();
			}

			getComplaintsDetailsData();
		}
	};
	return (
		<div className="modal-confirmation">
			{!!formErrorMessage ? (
				<div className="form-validation-error">{formErrorMessage}</div>
			) : (
				<SwitchTransition mode="out-in">
					<CSSTransition key={`key_${isLoading}`} timeout={600} classNames="standalone-fade" mountOnEnter unmountOnExit>
						{isLoading ? (
							<LoadingSpinner show={isLoading} />
						) : (
							<>
								<figure className="icon">
									<AlertIcon />
								</figure>

								<h2 className="heading h4">
									Are you sure you wish to remove <strong> '{familyMemberDetail.name}'?</strong>
								</h2>

								<section className="actions">
									<Button className="btn-primary full-width" onClick={confirmRemove}>
										Yes
									</Button>

									<Button className="btn-secondary full-width" onClick={closeModal}>
										Cancel
									</Button>
								</section>
							</>
						)}
					</CSSTransition>
				</SwitchTransition>
			)}
		</div>
	);
};

export default RemoveModal;
